import React from 'react'

import aSync from 'async'
import moment from 'moment'
import _ from 'lodash'

import OrderActions from '../../actions/OrderActions.js'
import CustomerActions from '../../actions/CustomerActions.js'
import AddressActions from '../../actions/AddressActions.js'

import {SplitButton, Modal, ModalHeader, ModalActions, Popup, Card, Colors, IconButton, H4, H5, ScrollView, Button, H6, Row, S2, P, Alert, Spinner} from '../UI/index.js'
import {formSpacing, FormRow, FormStack, Input, MetricInput, TextArea, CurrencyInput, DatePicker, Toggle, Select, Recurrence} from '../UI/forms/index.js'
import {priceTableHasFixedLocation} from '../../../utils/priceTableLocation.js'
import Addresses from './Addresses.js'
import EditCollo from './EditCollo.js'
import OrderCard from './OrderCard.js'
import NewOrder from '../../../server/functions/orders/NewOrder.js'
import EditAddress from './EditAddress.js'
import EditRouteModal from '../routes/EditRouteModal.js'
import time from 'server/utils/time.js'
import barcodes from 'server/utils/barcodes.js'
import DividerHeader from '@components/UI/surfaces/DividerHeader.js'
import dbCodes from 'server/dbCodes.js'
import t from '../../helpers/Languages.js'
import {getAvailableBranches} from 'src/utils/branches.js'
import {deriveOrderBranchId} from '@utils/deliveryZones.js'
import {prependDefaultOrderNotes, stripDefaultOrderNotes} from '@utils/defaultOrderNotes.js'
import {isEmptyCollo, showHiddenCollo} from '@utils/emptyCollo.js'
import naturalSortBy from '../../utils/naturalSortBy.js'

export default class EditOrderModal extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            modalIsOpen: false,
            createOrderMode: localStorage.createOrderMode || 'save',
            editTemplate: false,
            orderLoading: false,
            orderError: null,
            order: NewOrder(),
            customer: {settings: {orders: {}, parcels: {}}},
            shifts: [],
            addressesChanged: false,
            showMore: false,
            referenceValid: true,
            customerValid: true,
            appliedCustomerDefaultOrderNotes: '',
            branchPicked: false,
            addressDistanceLoading: false,
            recentCustomerOrders: [],
            priceLoading: false,
            editAll: false,
            removeAll: false,
            loading: false,
            message: '',
            error: ''
        }

        this.state = structuredClone(this.initialState)
        this.modalSessionId = 0 // so we can track the modal "session" across open/close calls
    }

    open(order, editTemplate, onOpen) {
        this.modalSessionId += 1
        const {reseller, planningDate, customers} = this.props

        order = order ? structuredClone(order) : NewOrder(reseller, {selectedDate: planningDate})

        if (editTemplate && !order.date) {
            order.date = order.startDate
        }

        if ('_id' in order && order._id) {
            console.log(order)
        }

        if (order.customer) {
            const customer = customers[order.customer]

            this.setState({customer})
        }

        this.setState({modalIsOpen: true, order, editTemplate}, onOpen)

        if (!order) {
            setTimeout(() => this.selectCustomer.focus(), 1)
        }
    }

    close(modalSessionId) {
        if (typeof modalSessionId === 'number' && modalSessionId !== this.modalSessionId) {
            return
        }

        this.setState(this.initialState)
    }

    onChangeDate(event) {
        const order = {...this.state.order}

        order.date = event.target.value

        this.setState({order})
    }

    // A new order shows the branch it will get as soon as the customer or an address is known, until a branch is picked
    deriveBranch(order, customer) {
        const {reseller} = this.props

        if (!order._id && !this.state.branchPicked && getAvailableBranches(reseller).length > 0) {
            order.branchId = deriveOrderBranchId(reseller, customer, order.addresses)
        }
    }

    onChangeBranch(event) {
        const order = {...this.state.order}

        order.branchId = event.target.value

        this.setState({order, branchPicked: true})
    }

    onChangeCustomer(event) {
        const {reseller, customers} = this.props
        const order = {...this.state.order}
        const {addressesChanged, appliedCustomerDefaultOrderNotes} = this.state

        const customer = customers[event.target.value]

        if (customer) {
            order.customer = customer._id
            order.contact = ''
            order.email = customer.email || ''
            order.phone = customer.phone || ''

            if (customer.settings.orders && !order._id) {
                if (!addressesChanged) {
                    const newOrderAddresses = NewOrder(reseller, {
                        defaultAddresses: customer.settings.orders.defaultAddresses !== 'default' ? customer.settings.orders.defaultAddresses : undefined
                    }).addresses
                    order.addresses = newOrderAddresses
                }

                order.addresses.map((address) => {
                    address.minimumAge = false
                    Object.keys(dbCodes.pickupAndDeliveryOptions).forEach((option) => {
                        address[option] = false
                    })

                    address.customOptions = []

                    if (address.type === 'pickup') {
                        let pickupOptions = reseller.settings.orders.defaultPickupOptions

                        if (customer.settings.orders.defaultPickupOptions && Array.isArray(customer.settings.orders.defaultPickupOptions)) {
                            pickupOptions = customer.settings.orders.defaultPickupOptions
                        } else if (customer.settings.orders.defaultPickupOptions === 'none') {
                            pickupOptions = []
                        }

                        for (const option of pickupOptions) {
                            if (option in dbCodes.pickupOptions) {
                                address[option] = true
                            } else {
                                address.customOptions = address.customOptions || []
                                address.customOptions.push(option)
                            }
                        }
                    }

                    if (address.type === 'delivery') {
                        let deliveryOptions = reseller.settings.orders.defaultDeliveryOptions

                        if (customer.settings.orders.defaultDeliveryOptions && Array.isArray(customer.settings.orders.defaultDeliveryOptions)) {
                            deliveryOptions = customer.settings.orders.defaultDeliveryOptions
                        } else if (customer.settings.orders.defaultDeliveryOptions === 'none') {
                            deliveryOptions = []
                        }

                        for (const option of deliveryOptions) {
                            if (option in dbCodes.pickupAndDeliveryOptions) {
                                if (option === 'minimumAge +16') {
                                    address.minimumAge = 16
                                } else if (option === 'minimumAge +18') {
                                    address.minimumAge = 18
                                } else if (option === 'minimumAge +21') {
                                    address.minimumAge = 21
                                } else {
                                    address[option] = true
                                }
                            } else {
                                address.customOptions = address.customOptions || []
                                address.customOptions.push(option)
                            }
                        }
                    }

                    if (address.customOptions?.length > 0) {
                        address.customOptions = [...new Set(address.customOptions)]
                    }
                })

                if (customer.settings.orders.generateReference) {
                    order.reference = order.reference || `${moment().format('YYMMDD')}-${Math.random().toString().substring(2, 5)}`
                }

                order.retourAddress = {
                    startTime: reseller?.settings?.account?.openingHours[moment().format('dddd').toLowerCase()] ?
                        reseller.settings.account.openingHours[moment().format('dddd').toLowerCase()].from :
                        '00:00',
                    endTime: reseller?.settings?.account?.openingHours[moment().format('dddd').toLowerCase()] ?
                        reseller.settings.account.openingHours[moment().format('dddd').toLowerCase()].till :
                        '23:59',
                    attention: '',
                    instructions: '',
                    ...customer.address
                }

                order.allowAddCollo = customer.settings.orders.allowAddCollo === 'default' ?
                    (reseller.settings.allowAddCollo || '') :
                    (customer.settings.orders.allowAddCollo || '')

                const customerDefaultOrderNotes = customer.settings.orders.defaultOrderNotes || ''
                order.notes = prependDefaultOrderNotes(customerDefaultOrderNotes, stripDefaultOrderNotes(appliedCustomerDefaultOrderNotes, order.notes || ''))
            }

            this.deriveBranch(order, customer)

            this.setState({
                customer,
                customerValid: true,
                appliedCustomerDefaultOrderNotes: !order._id ? (customer.settings.orders.defaultOrderNotes || '') : ''
            }, () => {
                this.setState({order}, () => {
                    if (!order._id) {
                        if (customer.address && order.addresses[0].type === 'pickup') {
                            if (!addressesChanged) {
                                order.addresses[0] = {
                                    ...order.addresses[0],
                                    ...customer.address
                                }
                                this.deriveBranch(order, customer)
                                this.setState({order})
                            }
                        } else {
                            this.addresses.focus()
                        }
                    }

                    OrderActions.getRecentCustomerOrders(customer._id, 20, 0, (err, recentCustomerOrders) => {
                        if (!err) {
                            this.setState({recentCustomerOrders, disableRecentCustomerOrdersBtn: false})
                        }
                    })

                    if (customer.settings.orders && customer.settings.orders.defaultPriceTable) {
                        this.onChangePricetableId({target: {value: customer.settings.orders.defaultPriceTable}})
                    }
                })
            })
        }
    }

    onChangeContact(event) {
        const {customer} = this.state
        const order = {...this.state.order}

        order.contact = event.target.value

        const contact = _.find(customer?.contacts, {name: order.contact})

        if (contact) {
            order.email = contact.email || order.email
            order.phone = contact.phone || order.phone
        }

        this.setState({order})
    }

    loadMoreRecentCustomerOrders() {
        const {recentCustomerOrders, customer} = this.state

        this.setState({recentCustomerOrdersLoading: true})

        OrderActions.getRecentCustomerOrders(customer._id, 10, recentCustomerOrders.length, (err, moreRecentCustomerOrders) => {
            if (!err) {
                this.setState({recentCustomerOrders: [...recentCustomerOrders, ...moreRecentCustomerOrders], recentCustomerOrdersLoading: false})
                if (moreRecentCustomerOrders.length === 0) {
                    this.setState({disableRecentCustomerOrdersBtn: true})
                }
            }
        })
    }

    selectRecentOrder(recentOrder) {
        const order = {...this.state.order}

        order.contact = recentOrder.contact
        order.email = recentOrder.email
        order.phone = recentOrder.phone
        order.addresses = []
        recentOrder.addresses.map((address) => {
            const newAddress = {
                type: address.type,
                name: address.name,
                attention: address.attention,
                street: address.street,
                nr: address.nr,
                addition: address.addition,
                street2: address.street2,
                postalCode: address.postalCode,
                city: address.city,
                country: address.country,
                email: address.email || '',
                phone: address.phone || '',
                instructions: address.instructions,
                startTime: address.startTime,
                endTime: address.endTime,

                gpsRequired: !!address.gpsRequired,
                signatureRequired: !!address.signatureRequired,
                nameRequired: !!address.nameRequired,
                signatureNeighbors: !!address.signatureNeighbors,
                scanRequired: !!address.scanRequired,
                imageRequired: !!address.imageRequired,
                statedAddressOnly: !!address.statedAddressOnly,
                mailboxDelivery: !!address.mailboxDelivery,
                refrigerated: !!address.refrigerated,
                idCheck: !!address.idCheck,
                minimumAge: address.minimumAge ?? undefined
            }

            if (address.position) {
                newAddress.position = JSON.parse(JSON.stringify(address.position))
            }

            order.addresses.push(newAddress)
        })
        order.distance = recentOrder.distance || 0
        order.priceTableId = recentOrder.priceTableId || ''
        order.price = recentOrder.price
        order.feeIds = recentOrder.feeIds
        order.reference = recentOrder.reference
        order.notes = recentOrder.notes
        order.autoRetour = recentOrder.autoRetour

        if (recentOrder.retourAddress) {
            order.retourAddress = recentOrder.retourAddress
        }

        order.monitorTemperature = recentOrder.monitorTemperature
        order.sensorId = recentOrder.sensorId
        order.sensorId = recentOrder.sensorId
        order.minTemperature = recentOrder.minTemperature
        order.maxTemperature = recentOrder.maxTemperature

        this.setState({order})
    }

    onChangePrice(price, fees) {
        const order = {...this.state.order}

        order.priceTableId = ''
        order.feeIds = []
        order.price = price
        order.fees = fees

        this.setState({order})
    }

    onChangeAddresses(addresses, getPrice) {
        const {reseller} = this.props
        const order = {...this.state.order}

        const addressesLengthChanged = order.addresses.length !== addresses.length

        const isDeliveryOrder = (addresses.length === 1 && addresses[0].type === 'delivery') || (addresses.length === 2 && addresses[0].type === 'pickup' && addresses[1].type === 'delivery')

        if (!isDeliveryOrder) {
            order.monitorTemperature = false
            order.sensorId = ''
            delete order.minTemperature
            delete order.maxTemperature
        }

        const deliveryAddressesLengthChanged = order.addresses.filter((address) => address.type === 'delivery').length !== addresses.filter((address) => address.type === 'delivery').length
        const pickupAddressLengthChanged = order.addresses.filter((address) => address.type === 'pickup').length !== addresses.filter((address) => address.type === 'pickup').length

        order.addresses = [...addresses]

        if (order.priceTableId) {
            const priceTable = _.find(reseller.settings.orders.prices, {id: order.priceTableId})

            if (priceTable?.distanceFeeType === 'distance' && !priceTableHasFixedLocation(priceTable) && order.addresses.length === 1) {
                order.priceTableId = ''
                order.feeIds = []
                order.price = '0,00'
            } else if (priceTable?.distanceFeeType === 'zones' && order.addresses.length > 2) {
                order.priceTableId = ''
                order.feeIds = []
                order.price = '0,00'
            } else if (addressesLengthChanged || deliveryAddressesLengthChanged || pickupAddressLengthChanged || getPrice || priceTable?.distanceFeeType === 'distance' || priceTable?.distanceFeeType === 'zones' || priceTable?.fuelFeeType === 'fuelFeeDistance') {
                this.calculateDistanceAndPrice(order, 500)
            }
        }

        this.deriveBranch(order, this.state.customer)

        this.setState({order, addressesChanged: true})
    }

    onChangeRetourAddress(address) {
        const order = {...this.state.order}

        order.retourAddress = address

        this.setState({order})
    }

    onChangeValue(path, parser, event) {
        if (!event) {
            event = parser
            parser = undefined
        }

        const order = {...this.state.order}

        if (path === 'status') {
            order[path] = parseInt(event.target.value)
        } else if (path === 'rrule') {
            if (!event.target.value) {
                delete order.rrule
            } else {
                order.rrule = event.target.value
            }
        } else {
            if (typeof parser === 'function') {
                _.set(order, path, parser(event.target.value))
            } else {
                _.set(order, path, event.target.value)
            }
        }

        this.setState({order})
    }

    calculateDistanceAndPrice(order, delay = 0) {
        this.setState({priceLoading: true})

        if (this.calculatePriceTimeout) {
            clearTimeout(this.calculatePriceTimeout)
        }

        this.calculatePriceTimeout = setTimeout(() => {
            OrderActions.getPrice(order, (err, price, distance, priceExplanation) => {
                const order = {...this.state.order}

                if (!err) {
                    order.price = price
                    order.distance = distance || 0
                    order.priceExplanation = priceExplanation || {}

                    this.setState({priceLoading: false, order})
                } else {
                    this.setState({priceLoading: false, error: err})
                }
            })
        }, delay)
    }

    onClickAddCollo() {
        const {reseller} = this.props
        const order = {...this.state.order}

        const pickupAddressIndex = order.addresses.findIndex((address) => address.type === 'pickup')
        const deliveryAddressIndex = order.addresses.findIndex((address) => address.type === 'delivery')

        const previousCollo = order.colli[order.colli.length - 1]

        // In a new order, a new collo follows the previous one in having a barcode or not
        const barcode = !order._id && previousCollo && (!previousCollo.barcode || previousCollo.barcode === 'no barcode') ? 'no barcode' : barcodes.generate()

        // The barcode of the first collo doubles as the track & trace code of the order
        if (!order.colli.length && !order.trackTrace) {
            order.trackTrace = barcode
        }

        const hiddenColloIndex = order._id ? order.colli.findIndex(isEmptyCollo) : -1

        if (hiddenColloIndex !== -1) {
            // Show a hidden empty collo instead of adding one next to it
            order.colli = order.colli.map((collo, index) => index === hiddenColloIndex ? showHiddenCollo(collo, barcode, pickupAddressIndex, deliveryAddressIndex) : collo)
        } else {
            order.colli = [...order.colli, {
                index: order.colli.length,
                type: '',
                description: '',
                weight: 0,
                length: 0,
                width: 0,
                height: 0,
                barcode,
                pickupAddressIndex,
                deliveryAddressIndex
            }]
        }

        if (order.priceTableId) {
            const priceTable = _.find(reseller.settings.orders.prices, {id: order.priceTableId})

            if (priceTable?.distanceFeeType === 'distance' && !priceTableHasFixedLocation(priceTable) && order.addresses.length === 1) {
                order.priceTableId = ''
                order.feeIds = []
                order.price = '0,00'
            } else if (priceTable?.distanceFeeType === 'zones' && order.addresses.length > 2) {
                order.priceTableId = ''
                order.feeIds = []
                order.price = '0,00'
            } else {
                this.calculateDistanceAndPrice(order, 500)
            }
        }

        this.setState({order})
    }

    onClickRemoveCollo(index) {
        const {reseller} = this.props
        const order = {...this.state.order}

        const colli = [...order.colli]
        colli.splice(index, 1)
        order.colli = colli

        if (order.priceTableId) {
            const priceTable = _.find(reseller.settings.orders.prices, {id: order.priceTableId})

            if (priceTable?.distanceFeeType === 'distance' && !priceTableHasFixedLocation(priceTable) && order.addresses.length === 1) {
                order.priceTableId = ''
                order.feeIds = []
                order.price = '0,00'
            } else if (priceTable?.distanceFeeType === 'zones' && order.addresses.length > 2) {
                order.priceTableId = ''
                order.feeIds = []
                order.price = '0,00'
            } else {
                this.calculateDistanceAndPrice(order, 500)
            }
        }

        this.setState({order})
    }

    onChangePricetableId(event) {
        const {reseller} = this.props
        const order = {...this.state.order}
        const priceTable = _.find(reseller.settings.orders.prices, {id: event.target.value})

        if (priceTable) {
            order.priceTableId = priceTable.id || ''
            order.feeIds = []
            order.price = '0,00'
            order.priceExplanation = {}

            this.setState({order})

            this.calculateDistanceAndPrice(order)
        } else {
            order.priceTableId = ''
            order.feeIds = []
            order.price = '0,00'
            order.priceExplanation = {}

            this.setState({order})
        }
    }

    onChangeFees(event) {
        const order = {...this.state.order}

        order.feeIds = [...event.target.values]

        this.setState({order}, () => {
            this.calculateDistanceAndPrice(order)
        })
    }

    onChangeChecked(key) {
        const order = {...this.state.order}
        order[key] = !order[key]

        if (key === 'autoRetour' && !order.retourAddress) {
            order.retourAddress = {
                name: '',
                attention: '',
                street: '',
                nr: '',
                addition: '',
                street2: '',
                postalCode: '',
                city: '',
                country: 'NL',
                instructions: ''
            }
        }

        this.setState({order})
    }

    onChangeSensorId(event) {
        const {reseller} = this.props
        const order = {...this.state.order}

        order.sensorId = event.target.value

        const sensor = _.find(reseller.settings.orders.sensors, {sensorId: order.sensorId})

        if (sensor) {
            order.minTemperature = sensor.minTemperature || 0
            order.maxTemperature = sensor.maxTemperature || 0
        }

        this.setState({order})
    }

    validate() {
        const {order} = this.state
        const {customers} = this.props

        const referenceRequired = customers[order.customer] ? customers[order.customer].settings.orders.referenceRequired : false
        const referenceValid = !referenceRequired || order.reference
        const customerValid = !!customers[order.customer]

        if (!referenceValid) {
            this.referenceInput?.focus()
        }

        if (!customerValid) {
            this.selectCustomer?.focus()
        }

        if (referenceValid && customerValid) {
            return true
        } else {
            this.setState({referenceValid, customerValid})
        }
    }

    async onSubmit(seperateOrders, event) {
        event.preventDefault()
        const {order, createOrderMode, editTemplate} = this.state
        const {customers, viewOrder} = this.props

        if (this.validate()) {
            const modalSessionId = this.modalSessionId

            this.setState({loading: true, error: ''})

            if (order._id) {
                if (order.rrule && editTemplate) {
                    if (!order.name) {
                        this.nameInput.setInvalid()
                        this.setState({loading: false, warning: 'Vul een naam in'})
                        return
                    }

                    this.popup.setInput({
                        type: 'date',
                        value: order.date > time.today() ? order.date : time.today(),
                        minDate: order.date > time.today() ? order.date : time.today(),
                        maxDate: order.endDate,
                        label: 'Datum'
                    })

                    const editDate = await this.popup.open('Rit template wijzigen', `Toekomstige ritten in de dagplanning zullen worden overschreven. Dit process gebeurt op de achtergrond. Wijzigingen worden pas zichtbaar in de dagplanning wanneer het process is afgerond, dit kan even duren.

Kies de datum vanaf wanneer deze wijziging van toepassing is.`, undefined, () => {
                        this.setState({loading: false})
                    })
                    if (editDate === undefined) return

                    this.close(modalSessionId)

                    OrderActions.editTemplate(order, editDate, (err) => {
                        if (err) {
                            // can throw an error if the component is unmounted
                            try {
                                this.popup.setError(err)
                            } catch {
                                alert(err)
                            }
                        }
                    })
                } else {
                    OrderActions.edit(order, (err, order) => {
                        if (err) {
                            this.setState({loading: false, error: err})
                        } else {
                            if (order && createOrderMode === 'save') {
                                viewOrder(order)
                                this.close(modalSessionId)
                            } else if (createOrderMode === 'saveNew') {
                                this.setState(this.initialState, () => {
                                    this.open()
                                })
                            } else {
                                this.close(modalSessionId)
                            }
                        }
                    })
                }
            } else {
                if (seperateOrders) {
                    aSync.eachSeries(order.addresses, (address, next) => {
                        const seperateOrder = JSON.parse(JSON.stringify(order))
                        seperateOrder.addresses = [address]

                        // Every separate order needs its own barcodes, colli without one stay without one
                        seperateOrder.trackTrace = ''
                        seperateOrder.colli = seperateOrder.colli.map((collo, index) => {
                            if (collo.barcode === 'no barcode') {
                                return collo
                            }

                            const barcode = barcodes.generate()

                            if (index === 0) {
                                seperateOrder.trackTrace = barcode
                            }

                            return {...collo, barcode}
                        })

                        OrderActions.create(seperateOrder, (err) => {
                            if (err) {
                                this.setState({loading: false, error: err})
                            } else {
                                next()
                            }
                        })
                    }, () => {
                        this.close(modalSessionId)
                    })
                } else {
                    if (!order.name && order.rrule) {
                        this.nameInput.setInvalid()
                        this.setState({loading: false, warning: 'Vul een naam in'})
                        return
                    }

                    if (order.rrule) {
                        this.close(modalSessionId)
                    }

                    OrderActions.create(order, (err, order) => {
                        if (err) {
                            if (order?.rrule) {
                                // can throw an error if the component is unmounted
                                try {
                                    this.popup.setError(err)
                                } catch {
                                    alert(err)
                                }
                            } else {
                                this.setState({loading: false, error: err})
                            }
                        } else {
                            if (order && createOrderMode === 'save') {
                                viewOrder(order)
                                this.close(modalSessionId)
                            } else if (createOrderMode === 'saveNew') {
                                this.setState(this.initialState, () => {
                                    this.open()
                                })
                            } else {
                                if (!order?.rrule) {
                                    this.close(modalSessionId)
                                }
                            }
                        }
                    })
                }
            }

            const customer = customers[order.customer]

            if (customer) {
                const contact = _.find(customer.contacts, {name: order.contact})
                if (!contact && order.contact) {
                    customer.contacts.push({name: order.contact, email: order.email, phone: order.phone})
                    CustomerActions.edit(customer)
                }
            }

            // The timeslot of the order is not the timeslot of the address in the address book
            const addressesToUpdate = _.filter(order.addresses, {save: true}).map((address) => _.omit(address, ['startTime', 'endTime']))

            if (addressesToUpdate.length) {
                AddressActions.update(addressesToUpdate)
            }
        }
    }

    render() {
        const {modalIsOpen, createOrderMode, orderLoading, orderError, order, loading, message, error, warning, editTemplate} = this.state
        const {customer, referenceValid, customerValid, showMore, recentCustomerOrders, priceLoading, recentCustomerOrdersLoading, disableRecentCustomerOrdersBtn} = this.state
        const {reseller, addressBook, customers, users} = this.props

        const priceTable = _.find(reseller.settings.orders.prices, {id: order.priceTableId})

        const showDays = (editTemplate || !order._id) && order.rrule && order.rrule.includes('FREQ=WEEKLY')
        const availableDays = {}

        if (showDays) {
            const splittedRrule = order.rrule.split('=')
            const rruleDays = splittedRrule.pop()

            rruleDays.split(',').map((day) => {
                if (day === 'MO') availableDays['monday'] = true
                if (day === 'TU') availableDays['tuesday'] = true
                if (day === 'WE') availableDays['wednesday'] = true
                if (day === 'TH') availableDays['thursday'] = true
                if (day === 'FR') availableDays['friday'] = true
                if (day === 'SA') availableDays['saturday'] = true
                if (day === 'SU') availableDays['sunday'] = true
            })
        }

        return (
            <Modal style={{width: 800}} show={modalIsOpen} onClose={this.close.bind(this)}>
                <ModalHeader title={order._id ? (editTemplate ? 'Bewerk rit template' : 'Bewerk rit') : order.rrule ? 'Nieuwe rit template' : 'Nieuwe rit'} onClose={this.close.bind(this)} />

                {orderLoading ?
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 250}}>
                        <Spinner color={Colors.textDark} />
                    </div> :
                    <form onSubmit={this.onSubmit.bind(this, false)}>
                        <div style={{position: 'relative'}}>
                            {!!recentCustomerOrders.length &&
                                <Card style={{position: 'absolute', top: 0, left: 800, width: 360, overflowY: 'auto'}}>
                                    <H4>Recente ritten</H4>

                                    <ScrollView style={{maxHeight: 700, marginTop: 12}}>
                                        {recentCustomerOrders.map((order) => {
                                            return (
                                                <OrderCard
                                                    key={order._id}
                                                    showDate={true}
                                                    showCustomer={false}
                                                    order={order}
                                                    onClick={() => this.selectRecentOrder(order)}
                                                    reseller={reseller}
                                                />
                                            )
                                        })}

                                        {recentCustomerOrders.length >= 20 &&
                                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                                                <Button
                                                    variant='text'
                                                    style={{marginBottom: 6, marginTop: 6}}
                                                    loading={recentCustomerOrdersLoading}
                                                    onClick={this.loadMoreRecentCustomerOrders.bind(this)}
                                                    disabled={disableRecentCustomerOrdersBtn}
                                                >
                                                    Laad meer
                                                </Button>
                                            </div>
                                        }
                                    </ScrollView>
                                </Card>
                            }

                            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                {order.rrule && editTemplate && (
                                    <Input
                                        label='Naam'
                                        value={order.name}
                                        onChange={(event) => {
                                            this.onChangeValue('name', undefined, event)

                                            if (event.target.value && warning) {
                                                this.setState({warning: undefined})
                                            }
                                        }}
                                        ref={(input) => this.nameInput = input}
                                    />
                                )}

                                {getAvailableBranches(reseller).length > 0 &&
                                    <Select
                                        label={t('branch')}
                                        value={order.branchId || ''}
                                        options={getAvailableBranches(reseller).map((branch) => {
                                            return {value: branch.id, title: branch.name}
                                        })}
                                        allowEmpty
                                        onChange={this.onChangeBranch.bind(this)}
                                    />
                                }

                                <FormRow>
                                    <FormRow style={{flex: 1}}>
                                        <Select
                                            label='Klant'
                                            options={_.values(customers).filter((customer) => !customer.isArchived).map((customer) => ({value: customer._id, title: customer.name}))}
                                            value={order.customer}
                                            readOnly={!createOrderMode && order.handledBy === 'reseller' && !!order.partnerId}
                                            isInvalid={!customerValid}
                                            onChange={this.onChangeCustomer.bind(this)}
                                            ref={(ref) => this.selectCustomer = ref}
                                        />

                                        <Input
                                            id='contact'
                                            label='Contactpersoon'
                                            suggestions={customer ? customer.contacts?.map((contact) => contact.name) : []}
                                            suggestionFilter
                                            value={order.contact}
                                            onChange={this.onChangeContact.bind(this)}
                                        />
                                    </FormRow>

                                    <FormRow style={{flex: 1}}>
                                        <DatePicker
                                            label={editTemplate ? 'Startdatum' : 'Datum'}
                                            value={order.date}
                                            minDate={editTemplate ? time.today() : undefined}
                                            disabled={editTemplate && order._id}
                                            onChange={this.onChangeDate.bind(this)}
                                            maxDate={order.endDate}
                                        />

                                        {order.rrule && editTemplate && (
                                            <DatePicker
                                                label='Einddatum'
                                                value={order.endDate}
                                                onChange={this.onChangeValue.bind(this, 'endDate')}
                                                minDate={(order.date && order.date > time.today()) ? order.date : time.today()}
                                                allowEmpty
                                            />
                                        )}
                                    </FormRow>
                                </FormRow>

                                <FormRow>
                                    <FormRow style={{flex: 1}}>
                                        <Input
                                            label='Emailadres'
                                            value={order.email}
                                            onChange={this.onChangeValue.bind(this, 'email')}
                                        />

                                        <Input
                                            label='Telefoon'
                                            type='phone'
                                            value={order.phone}
                                            onChange={this.onChangeValue.bind(this, 'phone')}
                                        />
                                    </FormRow>

                                    <FormRow style={{flex: 1}}>
                                        <Recurrence
                                            style={{flex: 1}}
                                            date={order.date}
                                            rrule={order.rrule}
                                            onChange={this.onChangeValue.bind(this, 'rrule')}
                                            ref={(ref) => this.recurrence = ref}
                                            disabled={!editTemplate}
                                        />

                                        {!order.rrule &&
                                            <TextArea
                                                label='Opmerkingen'
                                                value={order.notes}
                                                onChange={this.onChangeValue.bind(this, 'notes')}
                                            />
                                        }
                                    </FormRow>
                                </FormRow>

                                {order.rrule && (
                                    <FormRow>
                                        <TextArea
                                            label='Opmerkingen'
                                            value={order.notes}
                                            onChange={this.onChangeValue.bind(this, 'notes')}
                                        />
                                        <div style={{flex: 1}} />
                                    </FormRow>
                                )}
                            </FormStack>

                            {customer?.settings.orders.newOrderInstructions &&
                                <Alert
                                    style={{marginBottom: 12}}
                                    variant='info'
                                    icon='mdi mdi-message-outline'
                                >
                                    {customer.settings.orders.newOrderInstructions}
                                </Alert>
                            }

                            {customer?.settings?.openingHours && (!customer.settings.openingHours[moment(order.date).format('dddd').toLocaleLowerCase()].open) &&
                                <Alert
                                    style={{marginBottom: 12}}
                                    variant='danger'
                                >
                                    {`${customer.name} is op deze dag niet geopend.`}
                                </Alert>
                            }

                            <Addresses
                                order={order}
                                reseller={reseller}
                                customer={customer}
                                customers={customers}
                                addresses={order.addresses}
                                addressBook={addressBook}
                                showAddAddressButton={order.type !== 'parcelPickup' && order.type !== 'parcelDelivery' && order.type !== 'retour'}
                                rrule={(editTemplate || !order._id) && order.rrule}
                                showDays={showDays}
                                availableDays={availableDays}
                                onChange={this.onChangeAddresses.bind(this)}
                                fillTimeslot
                                ref={(ref) => this.addresses = ref}
                            />

                            <Row style={{alignItems: 'center', marginTop: 24}}>
                                <H5 style={{marginBottom: 24, flex: 1}}>Inhoud</H5>
                            </Row>

                            {order.colli.map((collo, index) => {
                                // The server adds an empty collo to every address without colli, those stay hidden in an existing order
                                if (order._id && isEmptyCollo(collo)) {
                                    return null
                                }

                                return (
                                    <Card key={`Collo${index}`} style={{padding: 0, marginBottom: 12}}>
                                        <EditCollo
                                            order={order}
                                            collo={collo}
                                            onChange={(collo) => {
                                                const order = {...this.state.order}
                                                order.colli[index] = collo
                                                this.setState({order}, () => {
                                                    if (order.priceTableId) {
                                                        this.calculateDistanceAndPrice(order, 500)
                                                    }
                                                })
                                            }}
                                            onRemove={this.onClickRemoveCollo.bind(this, index)}
                                            reseller={reseller}
                                            customer={customer}
                                        />
                                    </Card>
                                )
                            })}

                            <Row>
                                <Button
                                    variant='outline-white'
                                    style={{marginBottom: 12}}
                                    onClick={this.onClickAddCollo.bind(this)}
                                    tooltip='Nieuwe collo'
                                    icon='mdi mdi-plus'
                                />
                            </Row>

                            <Row style={{alignItems: 'center', marginTop: 24}}>
                                <H5 style={{marginBottom: 24, flex: 1}}>Administratie</H5>
                            </Row>

                            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                <FormRow>
                                    <Toggle
                                        label='Rit factureren'
                                        checked={!order.dontInvoice}
                                        onChange={this.onChangeChecked.bind(this, 'dontInvoice')}
                                    />

                                    <DatePicker
                                        label='Factuurdatum'
                                        value={!order._id ? order.date : order.invoiceDate}
                                        onChange={this.onChangeValue.bind(this, 'invoiceDate')}
                                        disabled={!order._id || order.dontInvoice || order.invoiced}
                                    />
                                </FormRow>

                                <FormRow>
                                    <Select
                                        loading={priceLoading}
                                        label={t('priceTable')}
                                        allowEmpty
                                        value={order.priceTableId}
                                        onChange={this.onChangePricetableId.bind(this)}
                                    >
                                        {naturalSortBy(reseller.settings.orders.prices || [], 'name').map((priceTable) => {
                                            let disabled = false

                                            if (priceTable?.distanceFeeType === 'distance' && !priceTableHasFixedLocation(priceTable) && order.addresses.length === 1) {
                                                disabled = true
                                            }
                                            if (priceTable.distanceFeeType === 'zones' && order.addresses.length > 2) {
                                                disabled = true
                                            }

                                            return (
                                                <option key={priceTable.id} value={priceTable.id} disabled={disabled}>{priceTable.name}</option>
                                            )
                                        })}
                                    </Select>

                                    <Select
                                        label='Toeslag'
                                        values={order.feeIds}
                                        options={(priceTable?.fees || []).filter((fee) => !fee.auto).map((fee) => {
                                            return {value: fee.id, title: fee.description}
                                        })}
                                        onChange={this.onChangeFees.bind(this)}
                                        disabled={!order.priceTableId || !priceTable}
                                    />
                                </FormRow>

                                <FormRow>
                                    <TextArea
                                        label='Referentie'
                                        value={order.reference}
                                        isInvalid={!referenceValid}
                                        onChange={this.onChangeValue.bind(this, 'reference')}
                                        ref={(ref) => this.referenceInput = ref}
                                    />

                                    <FormRow style={{flex: 1}}>
                                        {order.priceTableId && priceTable?.distanceFeeType === 'distance' && typeof order.distance === 'number' &&
                                            <>
                                                {order.customDistance ?
                                                    <>
                                                        <MetricInput
                                                            label='Afstand'
                                                            value={order.distance}
                                                            onChange={(event) => {
                                                                this.onChangeValue('distance', undefined, event)
                                                                order.distance = event.target.value
                                                                this.calculateDistanceAndPrice(order)
                                                            }}
                                                            precision={2}
                                                            append='km'
                                                        />
                                                        <IconButton
                                                            icon='mdi mdi-refresh'
                                                            onClick={() => {
                                                                order.customDistance = false
                                                                this.setState({order}, () => {
                                                                    this.calculateDistanceAndPrice(order)
                                                                })
                                                            }}
                                                            tooltip='Afstand herberekenen'
                                                        />
                                                    </> :
                                                    <>
                                                        <Input
                                                            label='Afstand'
                                                            value={`${order.distance.toString().replace('.', ',')} km`}
                                                            readOnly
                                                        />
                                                        <IconButton
                                                            icon='mdi mdi-pencil'
                                                            onClick={() => {
                                                                this.setState({order: {...order, customDistance: true}})
                                                            }}
                                                        />
                                                    </>
                                                }
                                            </>
                                        }

                                        <CurrencyInput
                                            label='Prijs'
                                            value={order.price === 'priceScale' ? 'n.t.b.' : order.price}
                                            onChange={this.onChangeValue.bind(this, 'price')}
                                            readOnly={order.priceTableId}
                                        />
                                    </FormRow>
                                </FormRow>
                            </FormStack>

                            <Row style={{alignItems: 'center', marginTop: 24, marginBottom: 12, cursor: 'pointer'}}>

                                <H5 style={{marginBottom: 24, flex: 1}} onClick={() => this.setState({showMore: !showMore})}>
                                    Overige opties
                                    <i className={showMore ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} />
                                </H5>
                            </Row>

                            {showMore &&
                                <>
                                    {((order.addresses.length > 2 || (order.addresses.length === 2 && order.addresses[0].type === order.addresses[1].type)) || (!reseller.isShop && (!order.templateId || (order.autoRetour && order.nrOfDeliveries > 0)))) &&
                                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                            {(order.addresses.length > 2 || (order.addresses.length === 2 && order.addresses[0].type === order.addresses[1].type)) &&
                                                <Select
                                                    label='Adres volgorde'
                                                    info='De volgorde waarin de rit gereden mag worden, de automatische routeoptimalisatie houdt hier rekening mee.'
                                                    value={order.addressOrder}
                                                    onChange={this.onChangeValue.bind(this, 'addressOrder')}
                                                >
                                                    <option value='fixed'>Vaste volgorde</option>
                                                    <option value='random'>Willekeurig</option>
                                                </Select>
                                            }

                                            {!reseller.isShop && !order.templateId &&
                                                <FormRow>
                                                    <Input
                                                        label='Aantal bezorgpogingen'
                                                        info='Ritten worden automatisch verplaatst naar de volgende werkdag na een mislukte bezorgpoging tot het maximaal aantal bezorgpogingen is bereikt. Vul 0 in om ritten nooit automatisch te verplaatsen.'
                                                        type='number'
                                                        min={0}
                                                        value={order.nrOfDeliveries}
                                                        onChange={this.onChangeValue.bind(this, 'nrOfDeliveries', parseInt)}
                                                    />

                                                    <Toggle
                                                        label='Automatisch retour'
                                                        checked={order.autoRetour}
                                                        onChange={this.onChangeChecked.bind(this, 'autoRetour')}
                                                    />
                                                </FormRow>
                                            }

                                            {!reseller.isShop && order.autoRetour && order.nrOfDeliveries > 0 &&
                                                <FormRow>
                                                    <Input
                                                        label='Bewaartijd'
                                                        info='Hoeveel dagen blijft de rit in bewaring na de laatste bezorgpoging. Vul 0 in om na de laatste bezorgpoging meteen een retourrit aan te maken.'
                                                        type='number'
                                                        value={order.nrOfDaysBeforeRetour}
                                                        onChange={(event) => this.onChangeValue('nrOfDaysBeforeRetour', parseInt, event)}
                                                    />
                                                    <div style={{flex: 1}} />
                                                </FormRow>
                                            }
                                        </FormStack>
                                    }

                                    {!reseller.isShop && order.autoRetour &&
                                        <>
                                            <H6 style={{marginBottom: 12}}>Retouradres</H6>

                                            <Card style={{width: '100%', background: Colors.grey20, padding: formSpacing.inset}}>
                                                <EditAddress
                                                    id='address-retour'
                                                    address={{...order.retourAddress, type: 'delivery'}}
                                                    addressBook={addressBook}
                                                    onChange={this.onChangeRetourAddress.bind(this)}
                                                    allowAttachments={true}
                                                    ref={(ref) => this.retourAddress = ref}
                                                    reseller={reseller}
                                                />
                                            </Card>
                                        </>
                                    }

                                    <FormStack style={{marginTop: formSpacing.rowGap, marginBottom: formSpacing.rowGap}}>
                                        <FormRow>
                                            <Select
                                                label='Collo toevoegen toestaan'
                                                info=''
                                                options={[
                                                    {title: 'Ja', value: 'yes'},
                                                    {title: 'Alleen bij bezorgen', value: 'deliver'},
                                                    {title: 'Alleen bij ophalen', value: 'pickup'},
                                                    {title: 'Nee', value: ''}
                                                ]}
                                                value={order.allowAddCollo}
                                                onChange={this.onChangeValue.bind(this, 'allowAddCollo')}
                                            />
                                            <div style={{flex: 1}} />
                                        </FormRow>

                                        {reseller.settings.orders.monitorTemperature &&
                                            <FormRow>
                                                <Toggle
                                                    label='Geconditioneerd transport'
                                                    checked={order.monitorTemperature}
                                                    onChange={this.onChangeChecked.bind(this, 'monitorTemperature')}
                                                />
                                                <div style={{flex: 1}} />
                                            </FormRow>
                                        }

                                        {order.monitorTemperature &&
                                            <FormRow>
                                                <Select
                                                    label='Sensor ID'
                                                    value={order.sensorId}
                                                    allowEmpty={true}
                                                    onChange={this.onChangeSensorId.bind(this)}
                                                >
                                                    {(reseller.settings.orders.sensors || []).map((sensor) => {
                                                        return (
                                                            <option key={sensor.id} value={sensor.sensorId}>{sensor.name}</option>
                                                        )
                                                    })}

                                                </Select>

                                                <FormRow style={{flex: 1}}>
                                                    <Input
                                                        id='minTemperature'
                                                        type='number'
                                                        label='Minimum temperatuur'
                                                        value={order.minTemperature || 0}
                                                        onChange={(event) => this.onChangeValue('minTemperature', parseInt, event)}
                                                    />

                                                    <Input
                                                        id='maxTemperature'
                                                        type='number'
                                                        label='Maximum temperatuur'
                                                        value={order.maxTemperature || 0}
                                                        onChange={(event) => this.onChangeValue('maxTemperature', parseInt, event)}
                                                    />
                                                </FormRow>
                                            </FormRow>
                                        }
                                    </FormStack>
                                </>
                            }
                        </div>

                        {editTemplate && order._id && (
                            <DividerHeader style={{marginBottom: 18}} title='Historie' defaultHidden>
                                <ScrollView style={{maxHeight: 250}}>
                                    {[...order.history].reverse().map((entry, index) => (
                                        <Row key={`history-${index}`} style={{alignItems: 'center', flexShrink: 0}}>
                                            <div style={{height: 10, width: 10, borderRadius: '50%', marginRight: 15, background: Colors.grey20}} />

                                            <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                                {entry.description ?
                                                    (
                                                        <P style={{whiteSpace: 'pre'}}>{entry.description}</P>
                                                    ) :
                                                    entry.type === 'create' ?
                                                        (
                                                            <P>Template aangemaakt</P>
                                                        ) :
                                                        entry.type === 'update' ?
                                                            (
                                                                <P>Template bijgewerkt</P>
                                                            ) :
                                                            null}
                                            </Row>

                                            <Row style={{paddingLeft: 6, paddingRight: 6, width: 200, minWidth: 'auto'}}>
                                                <S2>{`${entry.who} | ${entry.timestamp ? moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss') : undefined}`}</S2>
                                            </Row>
                                        </Row>
                                    ))}
                                </ScrollView>
                            </DividerHeader>
                        )}

                        {message &&
                            <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>
                        }
                        {error &&
                            <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                        }
                        {warning &&
                            <Alert style={{marginBottom: 6}} variant='warning'>{warning}</Alert>
                        }

                        <ModalActions>
                            <SplitButton
                                type='submit'
                                loading={loading}
                                value={createOrderMode}
                                options={[
                                    {title: 'Opslaan', value: 'save'},
                                    {title: 'Opslaan + Nieuw', value: 'saveNew'},
                                    ...!order.rrule ? [{title: 'Opslaan + Sluiten', value: 'saveClose'}] : [],
                                    ...order.addresses.length > 2 ? [{title: 'Aparte rit per adres', action: (event) => this.onSubmit(true, event)}] : []
                                ]}
                                onChange={(event) => {
                                    localStorage.createOrderMode = event.target.value
                                    this.setState({createOrderMode: event.target.value})
                                }}
                            >
                                {
                                    createOrderMode === 'saveNew' ?
                                        'Opslaan + Nieuw' :
                                        createOrderMode === 'saveClose' ?
                                            'Opslaan + Sluiten' :
                                            'Opslaan'
                                }
                            </SplitButton>
                        </ModalActions>
                    </form>
                }

                {orderError &&
                    <Alert style={{marginBottom: 6}} variant='danger'>{orderError}</Alert>
                }

                <Popup ref={(ref) => this.popup = ref} />
                <EditRouteModal reseller={reseller} users={users} ref={(ref) => this.editRouteModal = ref} />
            </Modal>
        )
    }
}
